// Shared site-wide constants for AB Events
// Official AB Events logo (gold AB monogram on transparent bg)
export const LOGO_URL = "/brand/ab-events-logo.png";
export const RUBHAAI_LOGO_URL = "/brand/rubai-cutout.png";
export const RUBHAAI_FEATURE_VIDEO_URL = "/videos/rubai-feature.mov";

export const CONTACT = {
  phone: "+91 9650506561",
  whatsapp: "+91 9650506561",
  email: "bookings@abevents.in",
  city: "Delhi, India",
  instagram: "https://www.instagram.com/abeventsofficialindia/",
  rubhaaiInstagram: "https://www.instagram.com/rubaithesufi/",
  youtube: "https://youtube.com/@abevents",
};

export const ARTIST_SPOTLIGHT = {
  name: "Deepak Malik",
  role: "Lead Vocalist & Artist",
  image: "/artists/deepak-malik.jpg",
  credential: "Performed on the Indian Idol stage",
  intro:
    "Deepak Malik brings the human signature to AB Events, holding the room with a voice that can move from intimate Sufi warmth to full-scale wedding lift without losing elegance.",
  description:
    "As the lead vocalist and featured artist, he anchors the emotional flow of the celebration, shaping key entries, reception builds and the moments guests remember long after the night ends.",
  strengths: [
    "Lead vocal direction for luxury wedding sets",
    "Strong room control across Sufi, ceremony and reception transitions",
    "National-stage confidence sharpened through his Indian Idol stage performance",
  ],
};

export const CEO_SPOTLIGHT = {
  name: "Anmol Baluja",
  role: "CEO, AB Events",
  image: "/founders/anmol-baluja.jpg",
  instagram: "https://www.instagram.com/anmolbaluja/",
  intro:
    "Anmol Baluja leads AB Events with a vision rooted in scale, discipline and emotional detail, shaping the brand into a premium live-experience company for modern Indian weddings.",
  description:
    "From artist direction and hospitality standards to stage flow and client confidence, he brings the structure behind the spectacle so every celebration feels elevated, personal and impeccably delivered.",
  quote:
    "Anmol Baluja brings the kind of leadership luxury celebrations depend on: calm judgment, strong creative instinct and an uncompromising standard for how every event should feel.",
  pillars: [
    "Leadership across artist curation, event flow and guest experience",
    "A premium-first approach to weddings, destination events and large-format celebrations",
    "Operational clarity that turns live performance into a polished, dependable experience",
  ],
};

export const AB_INSTAGRAM_PROFILE_URL =
  "https://www.instagram.com/abeventsofficialindia/";

export const RUBHAAI_INSTAGRAM_PROFILE_URL =
  "https://www.instagram.com/rubaithesufi/";

export const AB_INSTAGRAM_MEDIA = [
  {
    id: "DW6DiYICbwr",
    kind: "reel",
    poster: "/social/ab/DW6DiYICbwr.jpg",
    video: "/social/ab/DW6DiYICbwr.mp4",
  },
  {
    id: "DWjTKPnkT4B",
    kind: "reel",
    poster: "/social/ab/DWjTKPnkT4B.jpg",
    video: "/social/ab/DWjTKPnkT4B.mp4",
  },
  {
    id: "DVyzFZhiYiJ",
    kind: "reel",
    poster: "/social/ab/DVyzFZhiYiJ.jpg",
    video: "/social/ab/DVyzFZhiYiJ.mp4",
  },
  {
    id: "DTxYdKqia8K",
    kind: "reel",
    poster: "/social/ab/DTxYdKqia8K.jpg",
    video: "/social/ab/DTxYdKqia8K.mp4",
  },
  {
    id: "DKjnK-3pRTL",
    kind: "post",
    poster: "/social/ab/DKjnK-3pRTL.jpg",
  },
];

export const RUBHAAI_INSTAGRAM_MEDIA = [
  {
    id: "rubai-live-extra",
    kind: "reel",
    poster: "/social/rubhaai/rubai-live-extra.png",
    video: "/social/rubhaai/rubai-live-extra.mp4",
    local: true,
  },
  {
    id: "DQtd5ILCSfL",
    kind: "reel",
    poster: "/social/rubhaai/DQtd5ILCSfL.jpg",
    video: "/social/rubhaai/DQtd5ILCSfL.mp4",
  },
  {
    id: "DJUV5W9JL3M",
    kind: "reel",
    poster: "/social/rubhaai/DJUV5W9JL3M.jpg",
    video: "/social/rubhaai/DJUV5W9JL3M.mp4",
  },
  {
    id: "DHlaywzpbo-",
    kind: "reel",
    poster: "/social/rubhaai/DHlaywzpbo-.jpg",
    video: "/social/rubhaai/DHlaywzpbo-.mp4",
  },
  {
    id: "DW8U4XluNEa",
    kind: "reel",
    poster: "/social/rubhaai/DW8U4XluNEa.jpg",
    video: "/social/rubhaai/DW8U4XluNEa.mp4",
  },
  {
    id: "DW6DiYICbwr",
    kind: "post",
    poster: "/social/rubhaai/DW6DiYICbwr.jpg",
  },
];

export const NAV_LINKS = [
  { label: "Home", href: "#hero" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Worldwide", href: "#worldwide" },
  { label: "Gallery", href: "#gallery" },
  { label: "Bookings", href: "#bookings" },
];

export const GALLERY = [
  {
    url: "https://images.pexels.com/photos/35843780/pexels-photo-35843780.jpeg",
    category: "Wedding Baraat",
    alt: "Vibrant Indian wedding ceremony",
  },
  {
    url: "https://images.unsplash.com/photo-1774438534037-c2a5e202366b",
    category: "Sangeet / Dhol",
    alt: "Traditional dhol players performing",
  },
  {
    url: "https://images.unsplash.com/photo-1719650932800-ebb72adb2d2a",
    category: "Live Concert",
    alt: "Live music stage performance",
  },
  {
    url: "https://images.unsplash.com/photo-1617405207340-954e2e19755c",
    category: "Corporate Stage",
    alt: "Luxury concert stage in the dark",
  },
];

export const SERVICES = [
  {
    id: "weddings",
    title: "Wedding Ceremonies",
    blurb:
      "Baraat, Sangeet, Mehendi, Reception — a full cinematic soundtrack for every ritual.",
    image:
      "https://images.pexels.com/photos/35843780/pexels-photo-35843780.jpeg",
    span: "md:col-span-8 md:row-span-2",
  },
  {
    id: "corporate",
    title: "Corporate Events",
    blurb:
      "Award nights, gala dinners, brand launches with bespoke live arrangements.",
    image:
      "https://images.unsplash.com/photo-1617405207340-954e2e19755c",
    span: "md:col-span-4",
  },
  {
    id: "private",
    title: "Private Parties",
    blurb:
      "Intimate sets curated for milestone birthdays, anniversaries & home soirees.",
    image:
      "https://images.unsplash.com/photo-1719650932800-ebb72adb2d2a",
    span: "md:col-span-4",
  },
  {
    id: "international",
    title: "International Destination Weddings",
    blurb:
      "We travel with you — Dubai, Bali, London, Italy, Thailand, the Maldives.",
    image:
      "https://images.unsplash.com/photo-1774438534037-c2a5e202366b",
    span: "md:col-span-12",
  },
];

export const TESTIMONIALS = [
  {
    name: "Aarav & Priya",
    location: "Udaipur, India",
    quote:
      "AB Events made our Sangeet feel like a movie. The dhol entry still gives our guests goosebumps.",
  },
  {
    name: "Reyansh Mehra",
    location: "Dubai, UAE",
    quote:
      "Flew them in for our destination wedding — flawless, professional, and absolutely magical.",
  },
  {
    name: "The Kapoor Family",
    location: "London, UK",
    quote:
      "The most elegant live band we've worked with. They understand luxury Indian weddings.",
  },
];

export const CASE_STUDIES = [
  {
    id: "udaipur-sangeet",
    city: "Udaipur, India",
    eventType: "Sangeet Celebration",
    lineup: "Dhol-led live ensemble with vocals, rhythm lift and family-singalong cues.",
    production:
      "Warm ballroom light, handheld wirelesses, entry cue sync and a polished sangeet stage handoff.",
    client: "Aarav & Priya",
    quote:
      "AB Events made our Sangeet feel like a movie. The dhol entry still gives our guests goosebumps.",
    poster: "/social/ab/DW6DiYICbwr.jpg",
    video: "/social/ab/DW6DiYICbwr.mp4",
  },
  {
    id: "dubai-destination",
    city: "Dubai, UAE",
    eventType: "Destination Wedding",
    lineup: "Travel-ready Sufi crossover band shaped for welcome nights, rituals and a premium final set.",
    production:
      "Venue-matched sound planning, hospitality-friendly stage flow and destination logistics built into the show.",
    client: "Reyansh Mehra",
    quote:
      "Flew them in for our destination wedding — flawless, professional, and absolutely magical.",
    poster: "/social/rubhaai/DQtd5ILCSfL.jpg",
    video: "/social/rubhaai/DQtd5ILCSfL.mp4",
  },
  {
    id: "london-reception",
    city: "London, UK",
    eventType: "Reception Night",
    lineup: "Luxury live band with refined Sufi textures, elegant vocal transitions and strong room control.",
    production:
      "Reception-ready sound, spotlight cues, LED-friendly stage styling and smooth planner coordination.",
    client: "The Kapoor Family",
    quote:
      "The most elegant live band we've worked with. They understand luxury Indian weddings.",
    poster: "/social/ab/DWjTKPnkT4B.jpg",
    video: "/social/ab/DWjTKPnkT4B.mp4",
  },
];

export const DESTINATIONS = [
  "Delhi",
  "Mumbai",
  "Udaipur",
  "Jaipur",
  "Goa",
  "Bengaluru",
  "Dubai",
  "Nepal",
  "Thailand",
];

export const ABOUT_SHOWCASE = [
  {
    title: "Cocktail",
    url: "/social/ab/DTxYdKqia8K.jpg",
    alt: "Cocktail evening guests under purple party lighting",
  },
  {
    title: "Private Party",
    url: "/social/rubhaai/DJUV5W9JL3M.jpg",
    alt: "Private party dance floor with guests celebrating",
  },
];
